import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import projects from "./projectsData";
import { useTranslation } from "react-i18next";

function ProjectSingleREIMAGINE() {
  const { t } = useTranslation();

  const project = projects.find((p) => p.i18nKey === "reimagine");

  const baseKey = "projects.reimagine";
  const ns = "projectsTranslation";

  const objectives = t(`${baseKey}.sections.objectives`, {
    ns,
    returnObjects: true,
  });
  const orri = t(`${baseKey}.sections.orri`, { ns, returnObjects: true });
  const activities = t(`${baseKey}.sections.activities`, {
    ns,
    returnObjects: true,
  });
  const team = t(`${baseKey}.sections.team`, { ns, returnObjects: true });

  return (
    <>
      <Navbar />
      <Bredcom />

      <div className="container mt-4 pt-40 project-detail reimagine-page">
        <div className="row">
          {/* LEFT */}
          <div className="col-md-8">
            <div className="content-container lower-content">
              {/* Header / Cover */}
              <div className="project-single-hero">
                <div className="project-single-cover">
                  {project?.coverImage && (
                    <img src={project.coverImage} alt="RE-IMAGINE cover" />
                  )}{" "}
                </div>

                <div className="project-single-header">
                  <div className="project-single-logo">
                    {project?.logoImage && (
                      <img src={project.logoImage} alt="RE-IMAGINE logo" />
                    )}
                  </div>
                </div>
              </div>

              {/* About */}
              <h3>{t(`${baseKey}.sections.aboutTitle`, { ns })}</h3>
              <p className="textjustify">
                {t(`${baseKey}.sections.aboutText`, { ns })}
              </p>

              {/* Objectives */}
              <h3>{t(`${baseKey}.sections.objectivesTitle`, { ns })}</h3>
              <div className="values-section">
                <ul>
                  {(Array.isArray(objectives) ? objectives : []).map(
                    (item, idx) => (
                      <li key={`obj-${idx}`}>{item}</li>
                    )
                  )}
                </ul>
              </div>

              {/* ORRI */}
              <h3>{t(`${baseKey}.sections.orriTitle`, { ns })}</h3>
              <div className="values-section">
                <ul>
                  {(Array.isArray(orri) ? orri : []).map((item, idx) => (
                    <li key={`orri-${idx}`}>{item}</li>
                  ))}
                </ul>
              </div>

              {/* Activities */}
              <h3>{t(`${baseKey}.sections.activitiesTitle`, { ns })}</h3>
              <div className="values-section">
                <ul>
                  {(Array.isArray(activities) ? activities : []).map(
                    (item, idx) => (
                      <li key={`act-${idx}`}>{item}</li>
                    )
                  )}
                </ul>
              </div>

              {/* Results */}
              <h3>{t(`${baseKey}.sections.resultsTitle`, { ns })}</h3>
              <p className="textjustify">
                {t(`${baseKey}.sections.resultsText`, { ns })}
              </p>

              {/* Team (UA) */}
              <h3>{t(`${baseKey}.sections.teamTitle`, { ns })}</h3>
              <div className="values-section values-section--team">
                <ul>
                  {(Array.isArray(team) ? team : []).map((item, idx) => (
                    <li key={`team-${idx}`}>{item}</li>
                  ))}
                </ul>
              </div>

              {/* EU disclaimer */}
              <div className="ofpep-section mt-30">
                <p className="textjustify">
                  <em>{t(`${baseKey}.page.euFundingDisclaimer`, { ns })}</em>
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT: Overview */}
          {/* RIGHT: Project Overview / Sidebar */}
          <div className="col-md-4 pt-10">
            <div className="info-column">
              <div className="inner-column3">
                <h3>{t(`${baseKey}.overview.title`, { ns })}</h3>

                <ul className="project-info">
                  {/* Project reference */}
                  <li>
                    <span className="icon">
                      <i className="fas fa-project-diagram" />
                    </span>
                    <div>
                      <h5>
                        {t(`${baseKey}.overview.projectReferenceLabel`, { ns })}
                      </h5>
                      <p>{t(`${baseKey}.overview.projectReference`, { ns })}</p>
                    </div>
                  </li>

                  {/* Call */}
                  <li>
                    <span className="icon">
                      <i className="fas fa-bullhorn" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.overview.callLabel`, { ns })}</h5>
                      <p>{t(`${baseKey}.overview.call`, { ns })}</p>
                    </div>
                  </li>

                  {/* Duration */}
                  <li>
                    <span className="icon">
                      <i className="fas fa-calendar-alt" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.overview.durationLabel`, { ns })}</h5>
                      <p>{t(`${baseKey}.overview.duration`, { ns })}</p>
                    </div>
                  </li>

                  {/* Programme */}
                  <li>
                    <span className="icon">
                      <i className="fas fa-briefcase" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.overview.programmeLabel`, { ns })}</h5>
                      <p>{t(`${baseKey}.overview.programme`, { ns })}</p>
                    </div>
                  </li>

                  {/* Lead institution */}
                  <li>
                    <span className="icon">
                      <i className="fas fa-university" />
                    </span>
                    <div>
                      <h5>
                        {t(`${baseKey}.overview.leadInstitutionLabel`, { ns })}
                      </h5>
                      <p>{t(`${baseKey}.overview.leadInstitution`, { ns })}</p>
                    </div>
                  </li>

                  {/* Partner institution */}
                  <li>
                    <span className="icon">
                      <i className="far fa-handshake" />
                    </span>
                    <div>
                      <h5>
                        {t(`${baseKey}.overview.partnerInstitutionLabel`, {
                          ns,
                        })}
                      </h5>
                      <p>
                        {t(`${baseKey}.overview.partnerInstitution`, { ns })}
                      </p>
                    </div>
                  </li>

                  {/* Contact */}
                  <li>
                    <span className="icon">
                      <i className="far fa-envelope" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.overview.contactLabel`, { ns })}</h5>
                      <p>
                        <a
                          href={`mailto:${t(
                            `${baseKey}.overview.contactEmail`,
                            { ns }
                          )}`}
                        >
                          {t(`${baseKey}.overview.contactEmail`, { ns })}
                        </a>
                      </p>
                    </div>
                  </li>

                  {/* Main reference website (canonical) */}
                  <li>
                    <span className="icon">
                      <i className="fas fa-link" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.overview.websiteLabel`, { ns })}</h5>
                      <p>
                        <a
                          href={project?.website}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          metropolitan.ac.rs/reimagine
                        </a>
                      </p>
                    </div>
                  </li>

                  {/* REINFORCING platform */}
                  <li>
                    <span className="icon">
                      <i className="fas fa-external-link-alt" />
                    </span>
                    <div>
                      <h5>
                        {t(`${baseKey}.overview.reinforcingLabel`, { ns })}
                      </h5>
                      <p>
                        <a
                          href={project?.reinforcingWebsite}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          reinforcing.eu
                        </a>
                      </p>
                    </div>
                  </li>

                  {/* LinkedIn */}
                  {project?.social?.linkedin && (
                    <li>
                      <span className="icon">
                        <i className="fab fa-linkedin-in" />
                      </span>
                      <div>
                        <h5>LinkedIn</h5>
                        <p>
                          <a
                            href={project.social.linkedin}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            RE-IMAGINE Project
                          </a>
                        </p>
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default ProjectSingleREIMAGINE;
